import React, { useEffect } from 'react';
import { useField } from 'formik';
import Tooltip from '../../Tooltip';
import STATES from './states';
import classNames from '../../../utility/classNames';
import DescriptionTooltipModal from './DescriptionTooltipModal';
import SelectComponent from 'react-dropdown-select';

function Select({
  label,
  defaultLabel = 'Choose an option',
  options,
  description,
  tooltipHeading,
  tooltipFormula,
  required,
  layout = 'default',
  preValue,
  ...props
}) {
  const [field, meta, helpers] = useField(props);
  const { value } = meta;
  const { setValue, setTouched } = helpers;
  const dropdownOptions = options === 'STATES' ? STATES : options;

  const selectedOption = dropdownOptions.find(
    (option) => option.value === value || option.value === value?.toString()
  );

  useEffect(() => {
    if (preValue) {
      setValue(preValue);
    }
  }, [preValue]);

  const handleValueChange = (data) => {
    if (!data || !data[0]) {
      setValue('');
      setTouched(true);
      return;
    }
    let value = data[0].value;
    if (!isNaN(value)) value = Number(value);
    setValue(value);
    setTouched(true);
  };

  // Custom CSS for the dropdown, since the react-dropdown-select library doesn't allow for custom classes
  const customCss = `#select-container div {
    width: 100% !important;
    border-radius: 4px;
    border: 1px solid transparent;
    height: 32px !important;
    margin: 0px;
  }
  #select-container div:focus {
    border: 1px solid #031A18;
    outline: 2px solid transparent;
    outline-offset: 2px;
  }
  .react-dropdown-select {
    height: 32px !important;
    padding: 4px 8px;
    min-height: 26px;
    display: flex;
    justify-content: space-between;
  }

  .react-dropdown-select-dropdown {
    min-height: 150px !important;
    top: 2rem;
  }

  .react-dropdown-select-input {
    font-size: 12px;
  }

  .react-dropdown-select-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .react-dropdown-select-dropdown-handle {
    max-width: 16px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: 300px;
  }

  
  
  `;

  return (
    <div
      className={classNames(
        (layout === 'compact' || layout === 'tableNoLabel') && 'my-0 space-y-0',
        layout === 'tableNoLabel' && 'w-full'
      )}
    >
      <style>{customCss}</style>
      <div
        className={classNames(
          'sm:grid sm:items-start sm:gap-2',

          (layout === 'compact' || layout === 'tableNoLabel') &&
            'sm:gap-4 pt-0 border-none',
          layout === 'tableNoLabel' ? 'sm:grid-cols-2' : 'sm:grid-cols-3-inputs'
        )}
      >
        {layout !== 'tableNoLabel' && (
          <label
            htmlFor={field.name}
            className={classNames(
              'h-full flex items-center',
              layout === 'stacked' && 'col-span-3'
            )}
          >
            <span className="text-md text-neutral-900 font-normal">
              {label}
              {required && (
                <span className="text-warning" title="required">
                  *
                </span>
              )}{' '}
              {description && layout === 'compact' && (
                <DescriptionTooltipModal description={description} />
              )}
              {description && layout !== 'compact' && (
                <Tooltip
                  text={description}
                  heading={tooltipHeading}
                  formula={tooltipFormula}
                  type="info"
                />
              )}
            </span>
          </label>
        )}

        <div
          className={classNames(
            layout === 'stacked' ? 'col-span-3' : 'col-span-2',
            'rounded'
          )}
        >
          <div
            className="flex w-full col-span-2"
            id="select-container"
            style={{
              div: {
                width: '100% important!',
              },
            }}
          >
            <SelectComponent
              options={dropdownOptions}
              values={[selectedOption || { label: defaultLabel, value: '' }]}
              wrapperClassName="w-full"
              onChange={handleValueChange}
              dropdownHeight="200px"
              color={''}
              className="block w-full border-transparent focus:border-primary bg-neutral-input focus:outline-none focus:ring-transparent focus:ring-2  text-md  h-8 rounded-md py-0 px-3 placeholder-neutral-500 placeholder-opacity-90 col-span-2  max-h-8"
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Select;
